<template>
  <div id="map">
    <div id="tip" v-if="show_tip">
        <SparkLine :data="selected_data" :width="180" :height="50" :highlight="day" />
        <div class="text" v-html="tip_text"></div>
    </div>
  </div>
</template>

<script>
import SparkLine from '../components/SparkLine.vue'
import { Map, tileLayer, svg, LatLng } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { scaleSqrt } from "d3-scale";
import { max } from "d3-array";
import * as d3 from 'd3'


export default {

  name: 'WorldMap',
  components: { SparkLine },
  props: {
    data: Array,
    day: Number,
    date: Date
  },

  data: function() {
    return {
      height:0,
      weight:0,
      flipMe: false,
      map: {},
      scale: {},
      show_tip: false,
      tip_text: "",
      svg: 0,
      selected_data: []
    }
  },

  watch:  {
     day: function() {
       this.updateMapValues()
    }
  },

  mounted() {
    var self = this;
    this.width = this.$el.clientWidth;
    this.height = this.$el.clientHeight;

    this.map = new Map('map',{zoomControl:false}).setView([25, 18], 3);


    new tileLayer('https://map1.vis.earthdata.nasa.gov/wmts-webmerc/VIIRS_CityLights_2012/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}', {
      attribution: 'Tiles &copy; GIBS by <a href="https://earthdata.nasa.gov">ESDIS</a>',
      bounds: [[-85.0511287776, -179.999999975], [85.0511287776, 179.999999975]],
      minZoom: 1,
      maxZoom: 8,
      format: 'jpg',
      time: '',
      tilematrixset: 'GoogleMapsCompatible_Level'
    }).setOpacity(0.7).addTo(this.map)

    /*
    new tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
      attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ',
      maxZoom: 16
    }).setOpacity(1).addTo(this.map)


    new tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/terrain-labels/{z}/{x}/{y}{r}.{ext}', {
      attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      subdomains: 'abcd',
      minZoom: 0,
      maxZoom: 18,
      ext: 'png'
    }).setOpacity(1).addTo(this.map)
    */

    new tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19
    }).setOpacity(0.7).addTo(this.map)


    this.svgLayer = svg().addTo(this.map)
    this.scale = function(d) {
      if (d > 0) return scaleSqrt().range([2, 200])
        .domain([ 0, max( this.data, function(d) { return max(d.confirmed); } )])(d)
      else return 0;
    }

    this.svg = d3.select(this.$el).select("svg")
    this.initMap();
    this.map.on("zoom", self.updateMapPositions)
    this.map.on("pan", self.updateMapPositions)
  },

  beforeDestroy() {
   if (this.map) {
     this.map.remove()
   }
  },

 methods: {

    updateMapPositions() {
      var self = this;

      d3.select("#map").selectAll("g").selectAll("circle")
        .data( self.data, ).attr("transform",
          function(d) {
            return "translate("+
              self.map.latLngToLayerPoint(new LatLng(d.Lat, d.Long)).x +","+
              self.map.latLngToLayerPoint(new LatLng(d.Lat, d.Long)).y +")";
          }
      )
    },

    updateMapValues() {
      var self = this;
      d3.select(".new").selectAll("circle")
        .data( self.data, )
        .attr("r", function(d) {
          return self.scale(d.new_confirmed[self.day] )
        });

      d3.select(".active").selectAll("circle")
        .data( self.data, )
        .attr("r", function(d) {
          return self.scale((d.active[self.day]))
        });

      d3.select(".deaths").selectAll("circle")
        .data( self.data, )
        .attr("r", function(d) {
          return self.scale(d.new_deaths[self.day])
        });
    },

    initMap() {
      var self = this;

      this.svg.append("g").attr("class","active")
        .selectAll("circle")
        .data( self.data, )
        .enter()
        .append("circle")
        .style("stroke", "#bbb")
        .style("opacity", .4)
        .style("fill", "#aaa")
        .attr("pointer-events","visible")
        .on("mouseover", function(d) { self.showTip(d, event) })
        .on("mousemove", function(d) {  self.showTip(d, event) })
        .on("mouseout", function(d) {  self.hideTip(d) })

      this.svg.append("g").attr("class","new")
        .selectAll("circle")
        .data( self.data, )
        .enter()
        .append("circle")
        .style("stroke", "black")
        .style("opacity", .4)
        .style("fill", "red")
        .attr("pointer-events","visible")
        .on("mouseover", function(d) { self.showTip(d, event) })
        .on("mousemove", function(d) {  self.showTip(d, event) })
        .on("mouseout", function(d) {  self.hideTip(d) })

      this.svg.append("g").attr("class","deaths")
        .selectAll("circle")
        .data( self.data, )
        .enter()
        .append("circle")
        .style("stroke", "black")
        .style("opacity", .7)
        .style("fill", "black")
        .attr("pointer-events","visible")
        .on("mouseover", function(d) { self.showTip(d, event) })
        .on("mousemove", function(d) {  self.showTip(d, event) })
        .on("mouseout", function(d) {  self.hideTip(d) })

      this.updateMapValues()
      this.updateMapPositions()
    },

    showTip(d, e) {
      // Tooltip
      var nf = d3.format(",d")
      this.selected_data = d.active;
      var text = "<strong> " + ((d['Province/State'].length > 1) ? d['Province/State'] : d['Country/Region'])
        +  "</strong>" + d3.timeFormat("%Y-%m-%d")(this.date) + " (SUM)<br>";
      text += "<hr>";
      text += "<strong>New:</strong> " + nf(d.new_confirmed[this.day]) + "<br>";
      text += "<strong>Active:</strong> " + nf(d.active[this.day]) + "<br>";
      text += "<strong>Recovered:</strong> " + nf(d.new_recovered[this.day])
        + " (" + nf(d.recovered[this.day]) +  ") <br>";
      text += "<strong>Deaths:</strong>" + nf(d.new_deaths[this.day])
       + " (" +  nf(d.deaths[this.day]) +  ") <br>";
      text += "<strong>Total:</strong>" + nf(d.confirmed[this.day]) +  " <br>";

      var scrollTop  = document.documentElement.scrollTop;
      var scrollLeft = document.documentElement.scrollLeft;

      this.tip_text = text;

      d3.select("#tip")
        .style('top', (e.clientY - 130) + scrollTop + 'px')
        .style('left', (e.clientX  + 20) + scrollLeft + 'px')
        .style('opacity', '1')
      this.show_tip = true;
    },

    hideTip() {
      d3.select("#tip").style('opacity', '0')
    }

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#map {
  padding:0;margin:0;
  height: 100%;
  width: 100%;
}
svg circle { cursor:crosshair;}

#tip {z-index:3001; position:absolute; background:rgba(255, 255, 255, 0.8); padding: 5px 10px;font-family:'Charactron';font-size:12px;color:#666;
  opacity: 0;
}
#tip strong { font-weight:normal; text-transform:uppercase; padding-right:10px; color:black}
#tip hr {border:0px; border-bottom:1px solid #333; margin-bottom:10px}
#tip .text { margin-top:10px}


.leaflet-tile-pane    {
  opacity:0.7;
  filter: gray;
  -webkit-filter: grayscale(1);
  filter: grayscale(1),
}

.leaflet-tile-pane .leaflet-layer:nth-child(1)   {
  opacity:1;
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

</style>
